import { useDataChange, useDataValue } from 'Simple/Data'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let changeIsMatching = useDataChange({
    context: 'tab',
    path: 'selected.sync_is_matching',
    viewPath: props.viewPath,
  })
  let isMatching = useDataValue({
    context: 'tab',
    path: 'selected.sync_is_matching',
    viewPath: props.viewPath,
  })

  return async function onChange(value, change) {
    switch (value?.status) {
      case 'matching': {
        if (!isMatching) {
          changeIsMatching(true)
        }
        return
      }
      case 'completed':
      case 'created':
      case 'discarded':
      case 'error':
      case 'processing': {
        changeIsMatching(false)
        return
      }
      case 'processed':
      default: {
        return
      }
    }
  }
}
